<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="critereRecherche">
    <div class="column is-12 pdb-0"
       :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('journalReglements.filtre.titre') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('journalReglements.filtre.sousTitre') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
      :class="[
        {'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dates"
            :label="$t('journalReglements.filtre.dates')">
          </input-periode>
        </div>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.domiciliationBancaire')">
          <qd-taginput
            v-if="domBancaireTags"
            v-model="domBancaireSelected"
            :data="domBancaireTags"
            type="is-primary"
            icon="magnify"
            autocomplete
            open-on-focus
            field="libelle"
            @typing="getFilteredDomBancaireTags"
            @input="getDomBancaireTag">
            <template slot-scope="props">
              {{ afficherBanque(props.option) }}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.referenceTire')">
          <b-input v-model="critereRecherche.referencePaiement ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.nomTire')">
          <b-input v-model="critereRecherche.emetteur ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.borneMontantRegle')">
          <div class="columns is-vcentered">
            <input-currency v-model="critereRecherche.borneCredit.borneMin"
                            class="column"
                            :peutEtreNegatif="true"
                            isNumber="true">
            </input-currency>
            <span class="column is-1">{{$t('compteTiers.filtres.montantsA')}}</span>
            <input-currency v-model="critereRecherche.borneCredit.borneMax"
                            class="column"
                            :peutEtreNegatif="true"
                            isNumber="true">
            </input-currency>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('remiseBancaire.filtre.modeReglement')">
          <qd-taginput v-if="modeReglementTags"
                        v-model="modeReglementSelected"
                        :data="modeReglementTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredModeReglementTags"
                        @input="getModeReglementTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <query-client-tag-input
          v-model="clientsSelected"
          :societeActiveId="societeActiveId"
          :label="$t('journalReglements.filtre.client')">
        </query-client-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.compteComptable')">
          <b-input v-model="critereRecherche.compteComptable ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('journalReglements.filtre.codeFactureOuContrat')">
          <b-input v-model="critereRecherche.codeFactureOuContrat ">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <user-tag-input
                      :label="$t('journalReglements.filtre.commercial')"
                      :blocked="userIsCommercialBlocked"
                      v-model="commercialSelected"
                      :items="listeCommercial">
        </user-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('journalReglements.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('journalReglements.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import inputPeriode from '@/components/general/inputPeriode';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import genererCritereRechercheJournalReglements from '@/services/journalReglements/genererCritereRechercheJournalReglements';
import * as types from '@/store/modules/journalReglements-mutation-type';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import initialUsers from '@/services/general/filters/filterinitUsers';
import inputCurrency from '@/components/general/inputCurrency';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');
const JournalReglements = createNamespacedHelpers('journalReglements');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  components: {
    errorMsgComponent,
    inputPeriode,
    queryClientTagInput,
    userTagInput,
    inputCurrency,
  },
  data() {
    return {
      constantes: {},
      errors: [],
      critereRecherche: null,
      domBancaireSelected: [],
      domBancaireTags: null,
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
      clientsSelected: [],
      listeCommercial: [],
      commercialSelected: [],
    };
  },
  computed: {
    ...JournalReglements.mapGetters({
      critereRechercheJournalReglements: 'critereRechercheJournalReglements',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    userIsCommercialBlocked() {
      return this.userIsCommercial && this.blocageFiltreCommercial;
    },
    domBancaire() {
      return this.parametre(PARAMETRES_KEYS.domiciliationBancaire);
    },
    modesReglement() {
      return this.parametre(PARAMETRES_KEYS.modeReglement);
    },
  },
  methods: {
    ...JournalReglements.mapMutations({
      setCritereRechercheJournalReglements: types.SET_CRITERE_JOURNAL_REGLEMENTS,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheJournalReglements);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametres([PARAMETRES_KEYS.domiciliationBancaire,
          PARAMETRES_KEYS.modeReglement]);
        const users = this.parametre(PARAMETRES_KEYS.utilisateur);
        await updateCritereWithParametreInterne(this.critereRecherche);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeDevis.filtre.noCommercial'));
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        this.listeDomBancaireBase = this.domBancaire;
        if (this.critereRecherche.domiciliationBancaireIds.length > 0) {
          this.domBancaireSelected = this.listeDomBancaireBase.filter((domBancaire) => {
            return this.critereRecherche.domiciliationBancaireIds.includes(domBancaire.id);
          });
        }
        this.listeModeReglementBase = this.modesReglement;
        if (this.critereRecherche.modeDeReglementIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.critereRecherche.modeDeReglementIds.includes(modeReglemnt.id);
          });
        }
        this.clientsSelected = this.critereRecherche.tiersIds;
        this.getDomBancaireTag();
        this.getModeReglementTag();
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        ]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    afficherBanque(domBancaire) {
      const libelle = `${domBancaire.libelle} -`;
      const libelleBanque = domBancaire.libelleBanque && domBancaire.libelleBanque !== 'null'
        ? domBancaire.libelleBanque : '';
      return `${libelle} ${libelleBanque}`;
    },
    appliquerCritere() {
      this.errors = [];
      if (this.critereRecherche.dates.dateFin
        && this.critereRecherche.dates.dateDebut
        > this.critereRecherche.dates.dateFin) {
        this.errors.push({
          message: 'validation.dateDebutGreaterDateFin',
        });
      }
      if (this.errors.length > 0) return;
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.domiciliationBancaireIds = this.domBancaireSelected
        .map((domBancaire) => {
          return domBancaire.id;
        });
      this.critereRecherche.modeDeReglementIds = this.modeReglementSelected.map((modeReglement) => {
        return modeReglement.id;
      });
      this.critereRecherche.tiersIds = this.clientsSelected;
      this.setCritereRechercheJournalReglements(this.critereRecherche);
      this.$emit('recherche');
    },
    async viderCritere() {
      this.critereRecherche = cloneDeep(this.critereRechercheJournalReglements);
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.domBancaireSelected = [];
      this.modeReglementSelected = [];
      this.clientsSelected = [];
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.getDomBancaireTag();
      this.getModeReglementTag();
      this.critereRecherche = genererCritereRechercheJournalReglements();
    },
    getDomBancaireTag() {
      this.domBancaireTags = this.listeDomBancaireBase.filter((domBancaire) => {
        return !this.domBancaireSelected.map(a => a.id).includes(domBancaire.id);
      });
    },
    getFilteredDomBancaireTags(text) {
      this.getDomBancaireTag();
      this.domBancaireTags = this.domBancaireTags.filter((domBancaire) => {
        return domBancaire.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
